import axios from "axios";
import { Component } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { validateExpenseHeaderForm } from '../../utils/validation';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';

export default class AddExpenseHeader extends Component {

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      reportid: '',
      status: '',
      projects: [],
      selectedProjectId: '',
      loading: false,
      userId: '',
      hasError: false,
      errMsg: "",
      completed: false,
      message: '',
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: ''
    }
  }
  fetchUserDate = async () => {
    let token = localStorage.getItem('token');
    axios({
      method: "get",
      url: "/checkToken",
      headers: { "Authorization": `Bearer ${token}` }
    })
      .then((res) => {
        this.setState({ isAuthenticated: true, loading: false, userId: res.data.authData.user.id });
        console.log("this is response", this.state.userId)
      })
      .catch((err) => {
        console.log(err)
        console.log(`Access: ${this.state.isAuthenticated}`);
      });
  }
  async componentDidMount() {
    this.fetchUserDate();
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/project', { headers });
      console.log("response", response);
      this.setState({ projects: response?.data, loading: false });

    } catch (error) {
      console.error("Error fetching project:", error);
      let errorMessage = "Failed to load project.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }

  pushProjectList = () => {
    let projectList = [];
    this.state.projects.map((project, index) => {
      projectList.push(
        <option key={index} value={project.id}>
          {project.name}
        </option>
      );
    });
    return projectList;
  };

  handleProjectChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };

    this.setState({ [name]: value });

    if (!value) {
      errors[name] = "Project selection is required";
    } else {
      delete errors[name];
    }

    this.setState({ errors });
  };

  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/expense-header-list");
      this.setState({ loading: false });
    }, 500);
  }



  onSubmit = async (e) => {
    // debugger;
    this.setState({ loading: true })
    e.preventDefault();
    const errors = validateExpenseHeaderForm(
      this.state.selectedProjectId
    );
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const expenseHeaderData = {
      project_id: this.state.selectedProjectId,
      empid: this.state.userId,
    };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    try {
      console.log(expenseHeaderData);
      await axios.post('/expenseHeader/add', expenseHeaderData, { headers });
      this.setState({
        completed: true,
        toastMessage: "Expense header created successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/expense-header-list");
      }, 900);
    } catch (error) {
      if (error.response) {
        console.error('Error response from server:', error.response.data.error);
        this.setState({
          completed: true,
          toastMessage: error.response.data.error,
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      } else {
        console.error('Error creating expense header:', error.message);
        this.setState({ hasError: true, errMsg: "An unexpected error occurred." });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      }
    }

  };

  render() {
    return (
      <div className="container-fluid  pt-4" >
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}

        />
        <CommonLoader isLoading={this.state.loading}>
          < >
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white"><strong>Add Expense Header</strong></Card.Header>
              <Card.Body>
                {this.state.loading ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="outline-primary" className="loader" />
                  </div>
                ) : (
                  <Form onSubmit={this.onSubmit}>
                    <Row className="mb-3">
                      <Col xs={12} md={4} lg={4}>
                        <Form.Group controlId="formProject">
                          <Form.Label className="text-muted required">
                            Select Project
                          </Form.Label>
                          <Form.Control
                            as="select"
                            className="form-select"
                            value={this.state.selectedProjectId}
                            onChange={this.handleProjectChange}
                            name="selectedProjectId"

                          >
                            <option value="" defaultValue disabled>
                              Choose Project...
                            </option>
                            {this.pushProjectList()}
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.selectedProjectId && (
                            <small className="text-danger">{this.state.errors.selectedProjectId}</small>
                          )}
                        </span>
                      </Col>
                    </Row>

                    <div className='add-cancel-btn '>
                      <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                        Add
                      </Button>
                      <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                    </div>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </>
        </CommonLoader >
      </div >
    )
  }
}
